<template>
    <div class="aviso-a" role="note" aria-label="Aviso sobre envio de documentos">
        <div class="aviso-a__icon" aria-hidden="true">
            <svg width="20" height="20" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12,2L1,21H23M12,6L19.53,19H4.47M11,10V14H13V10M11,16V18H13V16" />
            </svg>
        </div>
        <div>
            <div class="aviso-a__title">Aviso sobre envio de documentos</div>
            <p class="aviso-a__intro">Para melhor funcionamento da análise na SollAI, não envie documentos:</p>
            <ul class="aviso-a__list">
                <li>Digitalizados (em formato de imagem/PDF escaneado)</li>
                <li>Bloqueados para cópia ou edição</li>
                <li>Com imagens muito grandes que possam comprometer o processamento</li>
            </ul>
            <p class="aviso-a__footer">Dê preferência a arquivos em formato <strong>.docx</strong>, <strong>.pdf</strong> editável.</p>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'AvisoUploadDocumentos',
    }
</script>

<style scoped>
    .aviso-a {
        position: relative;
        display: flex;
        align-items: flex-start;
        gap: 12px;
        padding: 14px 18px;
        margin-bottom: 1rem;
        border-radius: 12px;
        background: linear-gradient(135deg, #fff8e1 0%, #ffecb3 100%);
        border: 1px solid rgba(212, 140, 23, 0.40);
        border-left: 4px solid #d48806;
    }

    .aviso-a__icon {
        flex-shrink: 0;
        width: 34px;
        height: 34px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 8px;
        background: rgba(212, 136, 6, 0.16);
        color: #c67600;
    }

    .aviso-a__title {
        font-weight: 700;
        font-size: 0.85rem;
        color: #8b5a00;
        margin: 2px 0 4px;
    }

    .aviso-a__intro {
        font-size: 0.8rem;
        color: #6b4500;
        margin: 0 0 6px;
        line-height: 1.5;
    }

    .aviso-a__list {
        list-style: none;
        padding: 0;
        margin: 0 0 7px;
        display: flex;
        flex-direction: column;
        gap: 3px;
    }

    .aviso-a__list li {
        position: relative;
        padding-left: 15px;
        font-size: 0.8rem;
        color: #6b4500;
        line-height: 1.45;
    }

    .aviso-a__list li::before {
        content: "";
        position: absolute;
        left: 2px;
        top: 8px;
        width: 4px;
        height: 4px;
        border-radius: 50%;
        background: #c67600;
    }

    .aviso-a__footer {
        font-size: 0.8rem;
        color: #6b4500;
        margin: 0;
        line-height: 1.5;
    }

    .aviso-a__footer strong {
        color: #8b5a00;
        font-weight: 700;
    }

/* O tema escuro global aplica cor clara em p/li/strong com !important,
       por isso as cores abaixo também precisam de !important. */
    [data-bs-theme="dark"] .aviso-a {
        background: linear-gradient(135deg, #2b2213 0%, #3a2c15 100%);
        border-color: rgba(251, 191, 36, 0.35);
        border-left-color: #f59e0b;
    }

    [data-bs-theme="dark"] .aviso-a__icon {
        background: rgba(251, 191, 36, 0.18);
        color: #fbbf24;
    }

    [data-bs-theme="dark"] .aviso-a__title {
        color: #fcd34d !important;
    }

    [data-bs-theme="dark"] .aviso-a__intro,
    [data-bs-theme="dark"] .aviso-a__footer,
    [data-bs-theme="dark"] .aviso-a__list li {
        color: #fde68a !important;
    }

    [data-bs-theme="dark"] .aviso-a__list li::before {
        background: #fbbf24;
    }

    [data-bs-theme="dark"] .aviso-a__footer strong {
        color: #fef3c7 !important;
    }
</style>
